'use client';

import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Button } from '@mantine/core';
export const LoginButton = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  return <Button visibleFrom="sm" variant="transparent" c="white" p={0} tt="uppercase" leftSection={<Icons className="icon-pr-line-log-in" fontSize={24} color="var(--mantine-color-prime-0)" />} onClick={() => setOpenModal(MODAL.LOGIN)}>
      {i18n._('Log in')}
    </Button>;
};